import { atom } from "jotai";

export const chartColorsAtom = atom<Record<string, echarts.Color>>({});
